import { connect } from 'react-redux'

import selectors from '../../duck/selectors'
import OrderComponent from './Order.component'

const mapStateToProps = (state, { orderId }): any => {
  const order = selectors.getOrderById(orderId, state)
  const isTargetApp = selectors.getIsTargetApp(state)

  return {
    order,
    isTargetApp,
  }
}

export default connect(mapStateToProps)(OrderComponent)
